import React from "react"
import {
  Login as LoginComponent
} from '../components/userActions';

const Login = () => <LoginComponent />

export default Login
